import AltQuoteOfferPanelHeader from "./AltQuoteOfferPanelHeader";

export default AltQuoteOfferPanelHeader;
